import { findIndex } from "ramda";
import * as React from "react";
import { connect } from "react-redux";
import { SPREAD } from "src/constants";
import { State } from "../../state";
import {
  getLanguage,
  getSpreadBalanceSheetsPeriods
} from "../model/spread/selector";
import { Spread } from "../model/spread/types";
import PAFColumn from "./PAFColumn";
import "./PersistentAccountingFormula.scss";

interface PersistentAccountingFormulaProps {
  periods: string[];
  spread?: Spread;
  language?: string | null;
}

interface PersistentAccountingFormulaState {
  activePeriodIndex: number;
}

export class PersistentAccountingFormula extends React.Component<
  PersistentAccountingFormulaProps,
  PersistentAccountingFormulaState
> {
  constructor(props: PersistentAccountingFormulaProps) {
    super(props);
    this.state = {
      activePeriodIndex: 0
    };
  }

  public choosePeriod = (event: React.MouseEvent<HTMLButtonElement>) => {
    const activePeriodIndex = findIndex(
      period => period === event.currentTarget.value,
      this.props.periods
    );
    this.setState({ activePeriodIndex });
  };

  public render() {
    const { periods, spread } = this.props;

    const totalAssetsValue = this.periodValue(
      (spread && spread.financialTemplate.totalAssetsValues) || []
    );
    const totalLiabsAndNetWorth = this.periodValue(
      (spread && spread.financialTemplate.totalLiabsAndNetWorthValues) || []
    );

    let totalAssetsLabel =
      (spread && spread.financialTemplate.totalAssetsLabel) ||
      SPREAD.FINANCIAL_TEMPLATE.TOTAL_ASSET_DEFAULT_LABEL;

    if (
      this.props.language &&
      spread &&
      spread.financialTemplate.totalAssetsTranslatedLabels &&
      spread.financialTemplate.totalAssetsTranslatedLabels[this.props.language]
    ) {
      totalAssetsLabel =
        spread.financialTemplate.totalAssetsTranslatedLabels[
          this.props.language
        ];
    }

    let totalLiabsAndNetWorthLabel =
      (spread && spread.financialTemplate.totalLiabsAndNetWorthLabel) ||
      SPREAD.FINANCIAL_TEMPLATE.TOTAL_LIAL_AND_NET_DEFAULT_LABEL;

    if (
      this.props.language &&
      spread &&
      spread.financialTemplate.totalLiabsAndNetWorthTranslatedLabels &&
      spread.financialTemplate.totalLiabsAndNetWorthTranslatedLabels[
        this.props.language
      ]
    ) {
      totalLiabsAndNetWorthLabel =
        spread.financialTemplate.totalLiabsAndNetWorthTranslatedLabels[
          this.props.language
        ];
    }

    return (
      <div className="PersistentAccountingFormula__container">
        <div className={"PersistentAccountingFormula__periods"}>
          {periods.map((period, index) => {
            const year = period.split("/")[2];
            return (
              <button
                className={this.displayAsActive(index)}
                key={period}
                onClick={this.choosePeriod}
                value={period}
              >
                {year}
              </button>
            );
          })}
        </div>
        <PAFColumn
          header={totalAssetsLabel.toUpperCase()}
          value={totalAssetsValue}
        />
        <PAFColumn
          header={totalLiabsAndNetWorthLabel.toUpperCase()}
          value={totalLiabsAndNetWorth}
        />
        <PAFColumn
          header="DIFFERENCE"
          value={totalAssetsValue - totalLiabsAndNetWorth}
          isDifference={true}
        />
      </div>
    );
  }

  private periodValue = (valuesForPeriods: Array<number | undefined>) => {
    return valuesForPeriods[this.state.activePeriodIndex] || 0;
  };

  private displayAsActive = (periodIndex: number) => {
    return periodIndex === this.state.activePeriodIndex ? "active" : "inactive";
  };
}

const mapStateToProps = (state: State) => ({
  periods: getSpreadBalanceSheetsPeriods(state),
  language: getLanguage(state)
});

export default connect(mapStateToProps)(PersistentAccountingFormula);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/PersistentAccountingFormula.tsx